module.exports = __webpack_public_path__ + "static/Banner carrousel home Enero-06-296312ae9b0e410f155272fb2870c440.jpg";